import React from "react";
import { Box, Typography, styled, Link, Grid } from "@mui/material";
import { COLORS } from "../../constants";
import { capitalize } from "lodash";

const SuggestionBlock = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "4px",
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${COLORS.border}`,
  marginRight: theme.spacing(1),
}));

const SearchSuggestionsMobile = ({ categoriesAndTypes, vendors = [] }) => {
  const popularSearches = [
    "DOE",
    "BETA",
    "X-APPEAL",
    "SHIELD",
    "TEKNOSA",
    "Q20",
  ];

  // Define the specific categories to display
  const selectedCategories = [
    "cooling_system",
    "service_parts",
    "brake_system",
    "oils_and_fluids",
    "sensors",
    "steering_and_suspension",
  ];

  // Custom display titles (only override the ones that need it)
  const titleOverrides = {
    steering_and_suspension: "Suspension",
  };

  const normalize = (s) => s?.toLowerCase().replace(/[\s-]+/g, "_") ?? "";

  const popularCategories = categoriesAndTypes
    .filter((category) =>
      selectedCategories.includes(normalize(category.productCategoryName)),
    )
    .map((category) => {
      const key = normalize(category.productCategoryName);
      const defaultTitle = capitalize(
        category.productCategoryName.replaceAll("_", " ").replaceAll("-", " "),
      );
      return {
        title: titleOverrides[key] || defaultTitle,
        slug: category.productCategoryId,
        image: category.productCategoryImage,
      };
    });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Popular Searches Section */}
      <Box
        sx={{
          backgroundColor: COLORS.background,
          p: 2,
          pt: 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 500, color: COLORS.lightText, mt: 0 }}
        >
          POPULAR SEARCHES
        </Typography>
        <Box sx={{ mt: 1 }}>
          {popularSearches.map((vendorName, index) => {
            const matched = vendors.find(
              (v) => v.name?.toUpperCase() === vendorName.toUpperCase(),
            );
            return (
              <Link
                key={index}
                href={
                  matched
                    ? `/products/all?vendor=${matched.vendorId}`
                    : undefined
                }
                variant="caption"
                sx={{
                  display: "block",
                  textDecoration: "none",
                  cursor: matched ? "pointer" : "default",
                  color: COLORS.darkText,
                  p: 1,
                  "&:hover": {
                    color: COLORS.primary,
                    backgroundColor: matched
                      ? COLORS.themeYellow
                      : "transparent",
                    fontWeight: matched ? "bold" : "normal",
                  },
                }}
              >
                {vendorName}
              </Link>
            );
          })}
        </Box>
      </Box>

      {/* Popular Categories Section */}
      <Box sx={{ p: 2, flex: 2, borderTop: `1px solid ${COLORS.border}` }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 500, color: COLORS.lightText, mt: 0, mb: 1 }}
        >
          POPULAR CATEGORIES
        </Typography>
        <Grid container spacing={1} sx={{ mt: 1 }}>
          {popularCategories.map((category, index) => (
            <Grid item xs={12} key={index}>
              <Link
                href={`/products/${category.slug}`}
                sx={{ textDecoration: "none", color: COLORS.darkText }}
              >
                <SuggestionBlock>
                  <ImageContainer>
                    <img
                      src={category.image}
                      alt={category.title}
                      style={{
                        width: "55px",
                        height: "55px",
                        objectFit: "contain",
                      }}
                    />
                  </ImageContainer>
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 500, color: COLORS.darkText }}
                  >
                    {category.title}
                  </Typography>
                </SuggestionBlock>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SearchSuggestionsMobile;
